export default __webpack_public_path__ + "assets/images/listen-icon4-c2a29dad.svg";